<template>
    <el-form-item class="mobile-form-item" label-width="0">
      <div v-loading="loading" class="w-[100%]">
        <el-input v-model="form.abstract" placeholder="请输入摘要内容" type="textarea" :rows="6" class="mobile-textarea" />
      </div>
    </el-form-item>
    <div class="button-container">
      <div class="flex justify-center">
        <el-Button type="primary" @click="handleGenerate" :loading="loading" class="mobile-button">重新生成</el-Button>
      </div>
    </div>
  </template>
  
  <script setup lang="ts">
  import { toRefs, onMounted, ref } from 'vue';
  import { defineProps } from 'vue';
  import { post } from '@/api/api';
  
  interface Props {
    form: any;
    isBackNavigation?: boolean; // 添加返回导航标识
  }
  const props = defineProps<Props>();
  const { form, isBackNavigation } = toRefs(props);
  const loading = ref(false);
  
  const generateAbstract = async () => {
    loading.value = true;
    try {
      const res = await post('/aiGenerate/digest', {
        title: form.value.name, // 使用第一步的标题字段
        content: '', // 将content字段设为空字符串
        keywords: Array.isArray(form.value.keywords) ? form.value.keywords.join(',') : form.value.keywords,
        literature: Array.isArray(form.value.literature)
          ? form.value.literature.map((item: any) => item.quote).join(',')
          : form.value.literature,
      });
      if (res && res.data && res.data.data) {
        form.value.abstract = res.data.data;
      }
    } catch (error) {
      console.error('生成摘要失败:', error);
    } finally {
      loading.value = false;
    }
  };
  
  onMounted(() => {
    // 只有在非返回导航或者摘要为空时才调用API
    // 如果是返回导航且已有摘要数据，则不重新请求
    if (!isBackNavigation?.value || !form.value.abstract) {
      generateAbstract();
    }
  });
  
  const handleGenerate = () => {
    console.log('重新生成');
    generateAbstract();
  };
  </script>
  
  <style scoped>
  .mobile-form-item {
    margin-bottom: 20px;
  }
  
  .mobile-textarea {
    width: 100%;
  }
  
  .mobile-textarea :deep(.el-textarea__inner) {
    font-size: 14px;
    line-height: 1.6;
    padding: 12px;
  }
  
  /* 移动端适配 */
  @media (max-width: 768px) {
    .mobile-form-item {
      margin-bottom: 16px;
    }
    
    .mobile-textarea :deep(.el-textarea__inner) {
      font-size: 13px;
      padding: 10px;
    }
  }
  
  /* 按钮容器样式 */
  .button-container {
    margin-top: 24px;
    padding: 0 16px;
  }
  
  .mobile-button {
    min-width: 100px;
    height: 36px;
    font-size: 13px;
    font-weight: 500;
  }
  
  /* 平板端按钮样式 */
  @media (max-width: 1024px) and (min-width: 769px) {
    .button-container {
      margin-top: 18px;
      padding: 0 10px;
    }
    
    .mobile-button {
      min-width: 90px;
      height: 34px;
      font-size: 12px;
    }
  }
  
  /* 移动端按钮样式 */
  @media (max-width: 768px) {
    .button-container {
      margin-top: 16px;
      padding: 0 8px;
    }
    
    .mobile-button {
      width: 100%;
      height: 40px;
      font-size: 14px;
    }
  }
  
  /* 小屏幕手机样式 */
  @media (max-width: 480px) {
    .button-container {
      margin-top: 14px;
      padding: 0 6px;
    }
    
    .mobile-button {
      height: 38px;
      font-size: 13px;
    }
  }
  </style>
  